import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import InputField from '@/components/field/InputFieldComponent.vue';
import AvatarField from '@/components/field/AvatarFieldComponent.vue';
import SelectField from '@/components/field/SelectFieldComponent.vue';
import CheckboxField from '@/components/field/CheckboxFieldComponent.vue';
import ToolTip from '@/components/general/ToolTipComponent.vue';
import FormComponent from '@/components/general/FormComponent.vue';
import TableComponent from "./components/general/TableComponent.vue";

const app = createApp(App);

app.component('InputField', InputField);
app.component('AvatarField', AvatarField);
app.component('SelectField', SelectField);
app.component('CheckboxField', CheckboxField);
app.component('ToolTip', ToolTip);
app.component('FormComponent', FormComponent);
app.component('TableComponent', TableComponent);

app.config.globalProperties.$isElectron = !!(window.electronAPI && window.electronAPI.isElectron);

app.use(router);
app.mount("#app");

const theme = localStorage.getItem('theme');
if (theme === 'light') {
    document.body.classList.add('light');
}
